import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Envelope = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5.32221C2 4.30449 2.82503 3.47946 3.84275 3.47946H12.1573C13.175 3.47946 14 4.30449 14 5.32221V10.6778C14 11.6955 13.175 12.5205 12.1573 12.5205H3.84275C2.82503 12.5205 2 11.6955 2 10.6778V5.32221ZM3.26722 5.10711L7.65216 7.94308C7.85465 8.07404 8.11504 8.0744 8.31789 7.94399L12.7324 5.10611C12.645 4.87348 12.4204 4.70796 12.1573 4.70796H3.84275C3.57918 4.70796 3.35439 4.87396 3.26722 5.10711ZM12.7715 6.54142L10.2697 8.1497L12.7715 10.511V6.54142ZM11.8092 11.292L9.20507 8.83412L8.98221 8.97738C8.37365 9.3686 7.59247 9.36752 6.98499 8.97463L6.76819 8.83441L4.15192 11.292H11.8092ZM3.2285 10.474L5.70552 8.14713L3.2285 6.54511V10.474Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Envelope;
